import { createContext, useContext, useRef } from "react";

const NavGuardContext = createContext(null);

// A page registers a dirty-check function; Layout consults it before
// navigating away and shows the Discard confirm when it returns true.
export const NavGuardProvider = ({ children }) => {
  const guardRef = useRef(null);
  const apiRef = useRef({
    setGuard: (fn) => { guardRef.current = fn; },
    clearGuard: () => { guardRef.current = null; },
    isBlocked: () => (guardRef.current ? guardRef.current() : false),
  });
  return <NavGuardContext.Provider value={apiRef.current}>{children}</NavGuardContext.Provider>;
};

export const useNavGuard = () => useContext(NavGuardContext);
